import { useTranslation } from "react-i18next";

import classNames from "../../utils/classNames";
import Tooltip from "../shared/Tooltip";

interface BayCapacityDotsProps {
  easyFilled: number;
  easyCap: number;
  mediumFilled: number;
  mediumCap: number;
  hardFilled: number;
  hardCap: number;
}

const dotClasses = (filled: number, cap: number, base: string) => {
  if (cap === 0) return "bg-gray-200";
  if (filled >= cap) return "bg-gray-400";
  return base;
};

export default function BayCapacityDots({
  easyFilled,
  easyCap,
  mediumFilled,
  mediumCap,
  hardFilled,
  hardCap,
}: BayCapacityDotsProps) {
  const { t } = useTranslation("production");

  return (
    <div className="flex items-center gap-x-2 text-[11px] text-gray-600">
      <Tooltip content={t("Easy: {{filled}} / {{cap}}", { filled: easyFilled, cap: easyCap })}>
        <span className="flex items-center gap-x-1 cursor-help">
          <span className={classNames("h-2 w-2 rounded-full", dotClasses(easyFilled, easyCap, "bg-green-500"))} />
          {easyFilled}/{easyCap}
        </span>
      </Tooltip>
      <Tooltip content={t("Medium: {{filled}} / {{cap}}", { filled: mediumFilled, cap: mediumCap })}>
        <span className="flex items-center gap-x-1 cursor-help">
          <span className={classNames("h-2 w-2 rounded-full", dotClasses(mediumFilled, mediumCap, "bg-amber-500"))} />
          {mediumFilled}/{mediumCap}
        </span>
      </Tooltip>
      <Tooltip content={t("Hard: {{filled}} / {{cap}}", { filled: hardFilled, cap: hardCap })}>
        <span className="flex items-center gap-x-1 cursor-help">
          <span className={classNames("h-2 w-2 rounded-full", dotClasses(hardFilled, hardCap, "bg-red-500"))} />
          {hardFilled}/{hardCap}
        </span>
      </Tooltip>
    </div>
  );
}
